module.exports = __webpack_public_path__ + "img/AT1.png";